import { render, staticRenderFns } from "./ownerRooms.vue?vue&type=template&id=7524515e"
import script from "./ownerRooms.vue?vue&type=script&lang=js"
export * from "./ownerRooms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports